/** @format */

// src/components/MeetingTabs.js

const MeetingTabs = ({ activeTab, handleTabChange }) => {
	return (
		<ul className="nav nav-tabs mb-4 px-2 border-bottom">
			<li className="nav-item">
				<button className={`nav-link fw-bold px-4 ${activeTab === 'about' ? 'active text-primary border-bottom border-primary border-2' : 'text-secondary border-2'}`} onClick={() => handleTabChange('about')}>
					<i className="fas fa-info-circle me-2"></i>About
				</button>
			</li>
			<li className="nav-item">
				<button className={`nav-link fw-bold px-4 ${activeTab === 'schedule' ? 'active text-primary border-bottom border-primary border-2' : 'text-secondary border-2'}`} onClick={() => handleTabChange('schedule')}>
					<i className="fas fa-clock me-2"></i>Schedule
				</button>
			</li>
			<li className="nav-item">
				<button className={`nav-link fw-bold px-4 ${activeTab === 'register' ? 'active text-primary border-bottom border-primary border-2' : 'text-secondary border-2'}`} onClick={() => handleTabChange('register')}>
					<i className="fas fa-file-signature me-2"></i>Registration
				</button>
			</li>
		</ul>
	);
};

export default MeetingTabs;
